import React, { useEffect, useContext, useState, useReducer } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { firebaseAuth } from "../../../providers/AuthProvider";
import firebase from "firebase/compat/app";
import { db } from "../../../firebase";
import "firebase/functions";
import "../../../assets/css/groups.css";
import moment from "moment";
import DataTable from 'react-data-table-component';
import { EventRecapDataContext } from "../EventRecapDataContext";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "./Pagination";
import { DismissibleTag, FieldWrapper, SwitchField, Tag } from "../ManageUi";

//  Internally, customStyles will deep merges your customStyles with the default styling.
const customStyles = {
    rows: {
        style: {
            minHeight: '72px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            fontWeight: 'bold',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};


// import * as Sentry from "@sentry/react";
const EventRecapGallery = () => {
    const navigate = useNavigate();
    const { user } = useContext(firebaseAuth);
    const reducer = (state, payload) => ({ ...state, ...payload });
    useContext(EventRecapDataContext);
    useState(null);
    useState(null);
    const [, setSearchText] = useState("");
    const [showArchive, setShowArchive] = useState(true);
    const [initDone, setInitDone] = useState(false);
    const [simpleView, setSimpleView] = useState(false);
    const history = useNavigate();
    const defaultFilter = JSON.parse(localStorage.getItem("recFilters"));
    const [recFilters, setRecFilters] = useState(defaultFilter ? defaultFilter : {
        search: "",
        status: "",
        startDate: "",
        endDate: "",
        pageIndex: 0,
    });
    const [data, setData] = useReducer(reducer, {
        items: [],
        isFetching: false,
        message: null,
    });
    const columns = React.useMemo(
        () => [
            {
                name: 'Name',
                selector: (row) => row.sysname,
                sortable: true,
                grow: 1,
                cell: (row) => (
                    <b>{row.sysname}</b>
                )
            },
            {
                name: 'Start Date',
                selector: (row) => row.startDate ? moment(row.startDate).format('MM/DD/YYYY') : '',
                sortable: true,
                grow: 1,
            },
            {
                name: 'End Date',
                selector: (row) => row.endDate ? moment(row.endDate).format('MM/DD/YYYY') : '',
                sortable: true,
                grow: 1
            },
            {
                name: 'Department',
                selector: (row) => row.department,
                sortable: true,
                grow: 1
            },
            {
                name: 'Contact Name',
                selector: (row) => `${row.contactFirst ?? ""} ${row.contactLast ?? ""}`,
                sortable: true,
                grow: 1
            },
            {
                name: 'Contact Email',
                selector: (row) => row.contactEmail,
                sortable: true,
                grow: 1,
                omit: simpleView
            },
            {
                name: 'Contact Phone',
                selector: (row) => row.contactPhone,
                sortable: true,
                grow: 1,
                omit: simpleView
            },
            {
                name: 'Event Reason',
                selector: (row) => row.eventReason,
                sortable: true,
                grow: 1,
                omit: simpleView
            },
            {
                name: 'Event Spend',
                selector: (row) => row.eventSpend,
                sortable: true,
                grow: 1,
                omit: simpleView
            },
            {
                name: 'Status',
                selector: (row) => row.status,
                sortable: true,
                grow: 1
            },
            {
                name: 'Tags',
                selector: (row) => {
                    // Use a Set to store unique captions
                    const uniqueCaptions = new Set();

                    // Iterate over all gallery images and add their captions to the Set
                    row.galleryImages?.forEach((image) => {
                        if (Array.isArray(image?.caption)) {
                            image.caption.forEach((caption) => uniqueCaptions.add(caption));
                        }
                    });

                    // Join the unique captions into a comma-separated string
                    return Array.from(uniqueCaptions).join(", ") || "";
                },
                sortable: true,
                grow: 1,
                omit: true
            },
            // {
            //     name: 'Actions',
            //     center: true,
            //     grow: 2,
            //     cell: (row) => (
            //         <div className="flex-1" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            //             {
            //                 // user.role <s= 2 &&
            //                 <PLinkPure
            //                     href={"/manage/event-recap/" + row.id}
            //                     onClick={() => {
            //                         // if(row.allowedUsers) {
            //                         //   let tmpUsers = [];
            //                         //   row.allowedUsers?.split(",").map((user) => {
            //                         //     tmpUsers.push({name:user});
            //                         //   });
            //                         //   row.allowedUsers = null;
            //                         //   row.usersAllowed = tmpUsers;
            //                         // }
            //                         // setCurrentEventRecapData(item);
            //                         // console.log(row.name);
            //                         // setEventRecapData(item);
            //                         setCurrentEventRecapData(row);
            //                         setEventRecapData(row);
            //                         sessionStorage.setItem("eventRecapData", JSON.stringify(row));
            //                     }}
            //                     className="btn btn-link fs-sm"
            //                     size="xx-small"
            //                     icon="edit"
            //                 >
            //                     Edit Event
            //                 </PLinkPure>
            //             }
            //             {user.role <= 1 &&
            //                 <PButtonPure
            //                     size="xx-small"
            //                     onClick={() => {
            //                         copyEvent(row);
            //                     }}
            //                     className={"btn btn-link fs-sm"}
            //                     icon="copy"
            //                 >
            //                     Copy
            //                 </PButtonPure>
            //             }
            //             {/* {row.status === "Active" && user.role <= 1 &&
            //                 <PButtonPure
            //                     size="xx-small"
            //                     onClick={() => {
            //                         archiveEventRecap(row);
            //                     }}
            //                     className={"btn btn-link fs-sm"}
            //                     icon="bookmark"
            //                     style={{ flex: "50%" }}
            //                 >
            //                     Archive
            //                 </PButtonPure>
            //             }
            //             {row.status === "Archived" && user.role <= 1 &&
            //                 <PButtonPure
            //                     size="xx-small"
            //                     onClick={() => {
            //                         restoreEvent(row);
            //                     }}
            //                     className={"btn btn-link fs-sm"}
            //                     icon="history"
            //                 >
            //                     Restore
            //                 </PButtonPure>
            //             } */}
            //             {user.role <= 1 &&
            //                 <PButtonPure
            //                     size="xx-small"
            //                     className="btn btn-link fs-sm"
            //                     onClick={() =>
            //                         window.confirm("Are you sure to delete this record?")
            //                             ? deleteItem(row)
            //                             : console.log("Action cancelled by user.")
            //                     }
            //                     icon="delete"
            //                 >
            //                     Delete
            //                 </PButtonPure>
            //             }

            //         </div>
            //     ),
            //     // ignoreRowClick: true,
            //     // button: true,
            // }
        ], [simpleView]);


    const fetch = async (tmpShowArchvie) => {
        setData({
            items: data.items,
            isFetching: true,
            message: null,
        });
        try {
            await firebase.auth();
            let getEventData = await firebase.functions().httpsCallable("appV2/getEventRecapData")
            let result = await getEventData({ userEmail: user.email, userRole: user.role, showArchive: (showArchive || tmpShowArchvie), gallery: true });
            setInitDone(true);
            let resultData = result.data;
            setData({
                items: resultData,
                isFetching: false,
                message: null,
            });
        }
        catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        if (user.isAuthenticated) {
            let tmpShowArchive = localStorage.getItem('showArchive');
            let tmpSearchText = localStorage.getItem('searchText');
            setShowArchive(tmpShowArchive === "true" ? true : false);
            setSearchText(tmpSearchText);
            fetch(tmpShowArchive === "true" ? true : false);
        } else {
            navigate('/manage/sign-in')

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: run-once init on mount; auth check and initial fetch should not re-fire on identity changes
    }, []);
    useEffect(() => {
        if (user.isAuthenticated && initDone) {
            fetch();
            console.log('fetching event recaps');
            console.log('archiveToggle');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: re-fetch only when archive toggle changes; fetch/initDone/auth captured intentionally
    }, [showArchive]);
    useEffect(() => {
        if (data.updateSort) {
            data.items.forEach((item, i) => {
                if (item.listedEvent && item.status === "Active")
                    item.sortOrder = i;
                else if (!item.listedEvent && item.status === "Active")
                    item.sortOrder = i + 10000;
                else if (item.status === "Archived")
                    item.sortOrder = i + 20000;
                db.collection("events").doc(item.id).set(item);
            });


            setData({ ...data, updateSort: false });
        }

    }, [data]);
    const alertCls =
        "rounded-md bg-red-500/10 px-3 py-2 text-sm text-red-700 ring-1 ring-inset ring-red-500/30 dark:text-red-300 dark:ring-red-500/20";
    function Fetching() {
        if (!data.isFetching) return null;
        return <div className={alertCls}>Loading items.</div>;
    }

    const filter = () => {
        console.log("Filtering...");
        let eventRecaps = data.items;
        if (!eventRecaps || eventRecaps.length === 0) {
            // let tempReg = JSON.parse(localStorage.getItem('regData'));
            // if(!tempReg || tempReg.length === 0) {
            //   tempReg = [];
            // }
            // registrations = tempReg;
            fetch();
            return;
        }
        let filteredRecs = [];

        eventRecaps.forEach((recap, i) => {
            recap.idx = i;

            if (recFilters && !recFilters.status && !recFilters.search && !recFilters.item && !recFilters.startDate && !recFilters.endDate && !recFilters.tags) {
                filteredRecs.push(recap);
            } else {
                let searchCheck = !recFilters?.search;
                let statusCheck = !recFilters?.status;
                let startDateCheck = !recFilters?.startDate;
                let endDateCheck = !recFilters?.endDate;
                let itemCheck = !recFilters?.item;
                let tagsCheck = !recFilters?.tags || recFilters?.tags.length === 0;

                if (!searchCheck) {
                    if (
                        recap.sysname
                            ?.toUpperCase()
                            .indexOf(recFilters?.search?.toUpperCase()) > -1 ||
                        recap.department
                            ?.toUpperCase()
                            .indexOf(recFilters?.search?.toUpperCase()) > -1 ||
                        recap.contactFirst
                            ?.toUpperCase()
                            .indexOf(recFilters?.search?.toUpperCase()) > -1 ||
                        recap.contactLast
                            ?.toUpperCase()
                            .indexOf(recFilters?.search?.toUpperCase()) > -1 ||
                        recap.contactEmail?.toUpperCase().indexOf(recFilters?.search?.toUpperCase()) >
                        -1
                    ) {
                        searchCheck = true;
                    }
                }
                if (!statusCheck) {
                    if (recap.status === recFilters?.status) {
                        statusCheck = true;
                    }
                }

                if (!startDateCheck) {
                    if (recap.startDate && recFilters?.startDate) {
                        let startDate = new Date(recap.startDate);
                        let filterStartDate = new Date(recFilters.startDate);
                        console.log("startDate", startDate, "filterStartDate", filterStartDate);
                        if (startDate >= filterStartDate) {
                            startDateCheck = true;
                        }
                    } else {
                        startDateCheck = false;
                    }
                }

                if (!endDateCheck) {
                    if (recap.endDate && recFilters?.endDate) {
                        let endDate = new Date(recap.endDate);
                        let filterEndDate = new Date(recFilters.endDate);
                        if (endDate <= filterEndDate) {
                            endDateCheck = true;
                        }
                    } else {

                        endDateCheck = false;
                    }
                }

                if (!tagsCheck) {
                    // Use a Set to store unique captions
                    const uniqueTags = new Set();

                    // Iterate over all gallery images and add their captions to the Set
                    recap.galleryImages?.forEach((image) => {
                        if (Array.isArray(image?.caption)) {
                            image.caption.forEach((caption) => uniqueTags.add(caption));
                        }
                    });

                    tagsCheck = recFilters.tags.every(tag => uniqueTags.has(tag));
                }


                if (searchCheck && statusCheck && itemCheck && startDateCheck && endDateCheck && tagsCheck) filteredRecs.push(recap);
            }

        });
        setData({ ...data, filtered: filteredRecs, filter: false });
    };


    useEffect(() => {
        localStorage.setItem("recFilters", JSON.stringify(recFilters));
        if (!data.isFetching) filter();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: re-run only on recFilters change; data.isFetching is a point-in-time guard and filter() is component-scope
    }, [recFilters]);

    const h1Cls = "text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100";
    const inputCls = "mt-2 block w-full rounded-md bg-zinc-50 px-3 py-2 text-sm text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-zinc-900 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:placeholder:text-zinc-500 dark:focus:ring-white";
    const primaryBtnCls = "inline-flex items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100";
    const secondaryBtnCls = "inline-flex items-center justify-center rounded-md bg-zinc-50 px-3 py-2 text-sm font-semibold text-zinc-900 ring-1 ring-inset ring-zinc-300 hover:bg-zinc-100 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:hover:bg-zinc-700";
    return (
        <div className="mx-auto max-w-7xl" id="event-recaps">
            <h1 className={h1Cls}>Event Recap Gallery</h1>
            <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-12">
                <div className="lg:col-span-9">
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:items-end">
                            <div className="md:col-span-12">
                                    <FieldWrapper label="Search">
                                        <input
                                            type="text"
                                            className={inputCls}
                                            name="Search"
                                            value={recFilters?.search}
                                            onChange={(e) => {
                                                setRecFilters({ ...recFilters, search: e.target.value });
                                            }}
                                            placeholder="Search"
                                        />
                                    </FieldWrapper>
                            </div>
                            <div className="md:col-span-12">
                                    <form onSubmit={(e) => {
                                        e.preventDefault();

                                        let tmpSearchFilters = { ...recFilters };

                                        tmpSearchFilters.tags = tmpSearchFilters.tags || [];
                                        if (tmpSearchFilters.searchTagInput && tmpSearchFilters.searchTagInput.trim() !== "") {
                                            // Check if the tag already exists
                                            if (!tmpSearchFilters.tags.includes(tmpSearchFilters.searchTagInput.trim())) {
                                                tmpSearchFilters.tags.push(tmpSearchFilters.searchTagInput.trim().toUpperCase());
                                            }
                                        }

                                        setRecFilters(tmpSearchFilters);

                                        e.target.reset();
                                        toast.success("Tag search applied successfully.");

                                        return;
                                    }}>
                                        <FieldWrapper label="Tags">
                                            <input
                                                type="text"
                                                className={inputCls}
                                                name="Tags"
                                                value={recFilters?.searchTagInput}
                                                onChange={(e) => {
                                                    setRecFilters({ ...recFilters, searchTagInput: e.target.value });
                                                }}
                                                placeholder="Search Tags"
                                            />
                                        </FieldWrapper>
                                    </form>
                                {recFilters?.tags && recFilters.tags.length > 0 && (
                                    <div className="mt-2 flex flex-wrap gap-2">
                                        {recFilters.tags.map((tag, index) => (
                                            <DismissibleTag
                                                key={index}
                                                onClick={() => {
                                                    const updatedTags = recFilters.tags.filter((t) => t !== tag);
                                                    setRecFilters({ ...recFilters, tags: updatedTags });
                                                    toast.info(`Tag "${tag}" removed from search.`);
                                                }}
                                            >
                                                {tag}
                                            </DismissibleTag>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="md:col-span-4">
                                    <FieldWrapper label="Status">
                                        <select
                                            className={inputCls}
                                            name="StatusSearch"
                                            value={recFilters?.status}
                                            onChange={(e) => {
                                                setRecFilters({ ...recFilters, status: e.target.value });
                                            }}
                                        >
                                            <option value="">- Select -</option>
                                            <option value="Active">Active</option>
                                            <option value="Archived">Archived</option>
                                        </select>
                                    </FieldWrapper>
                            </div>
                            <div className="md:col-span-4">
                                    <FieldWrapper label="Start Date">
                                    <DatePicker
                                        className={inputCls}
                                        selected={recFilters?.startDate ? new Date(recFilters.startDate) : null}
                                        dateFormat="MM/dd/yyyy"
                                        // onSelect={handleDateSelect} //when day is clicked
                                        onChange={(date) => setRecFilters({ ...recFilters, startDate: date })}
                                        placeholderText='Start Date'
                                        required
                                    />
                                    </FieldWrapper>
                            </div>
                            <div className="md:col-span-4">
                                    <FieldWrapper label="End Date">
                                    <DatePicker
                                        className={inputCls}
                                        selected={recFilters?.endDate ? new Date(recFilters.endDate) : null}
                                        dateFormat="MM/dd/yyyy"
                                        // onSelect={handleDateSelect} //when day is clicked
                                        onChange={(date) => setRecFilters({ ...recFilters, endDate: date })}
                                        placeholderText='End Date'
                                        required
                                    />
                                    </FieldWrapper>
                            </div>
                            <div className="md:col-span-12">
                                <button
                                    className={secondaryBtnCls}
                                    onClick={() => {
                                        setRecFilters({ search: "", status: "", item: "" });
                                    }}
                                >
                                    Clear
                                </button>
                            </div>
                            {/* <div className="col-auto text-end">
                                <div className="field-container">
                                    <div className="field-select"
                                        onClick={(e) => {
                                            setShowFieldList(!showFieldList);
                                        }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%" focusable="false"><path d="M12 8a4 4 0 104 4 4 4 0 00-4-4zm0 7a3 3 0 113-3 3 3 0 01-3 3z"></path><path d="M18.84 13a5.81 5.81 0 00.08-1 6.19 6.19 0 00-.08-1.07l1.78-1.5a7.24 7.24 0 00-.53-1.36 9.09 9.09 0 00-.65-1.14 8.56 8.56 0 00-.93-1.14l-2.2.8a6.71 6.71 0 00-1.8-1l-.41-2.3A8.63 8.63 0 0012.66 3h-1.32a8.63 8.63 0 00-1.44.22l-.41 2.3a6.71 6.71 0 00-1.8 1l-2.2-.8a8.56 8.56 0 00-.93 1.14A9.09 9.09 0 003.91 8a7.24 7.24 0 00-.53 1.36l1.78 1.5A6.19 6.19 0 005.08 12a5.81 5.81 0 00.08 1l-1.79 1.5a8.62 8.62 0 00.52 1.37A9.09 9.09 0 004.54 17a11.18 11.18 0 00.92 1.14l2.19-.79a6.74 6.74 0 001.84 1.06l.41 2.3a7.81 7.81 0 001.45.22h1.3a7.81 7.81 0 001.45-.22l.41-2.3a6.74 6.74 0 001.84-1.06l2.19.79a11.18 11.18 0 00.92-1.14 9.09 9.09 0 00.65-1.14 8.62 8.62 0 00.52-1.37zm.36 2.45a6.64 6.64 0 01-.57 1c-.12.19-.26.36-.39.53l-1.55-.55-.53-.2-.44.36a5.9 5.9 0 01-1.57.91l-.53.2-.1.56-.29 1.63-.68.07L12 20h-.59c-.22 0-.43 0-.64-.06l-.29-1.63-.1-.56-.53-.2a5.9 5.9 0 01-1.57-.91l-.44-.36-.53.2-1.55.52-.39-.52a7.41 7.41 0 01-.58-1c-.09-.19-.18-.39-.26-.6L5.8 13.8l.44-.37-.09-.56a4.94 4.94 0 01-.07-.87 5.62 5.62 0 01.07-.92l.09-.55-.44-.37L4.54 9.1c.08-.2.17-.39.26-.59a9.31 9.31 0 01.58-1L5.79 7l1.56.57.52.19.44-.35a5.62 5.62 0 011.53-.88l.53-.2.1-.56.29-1.63c.22 0 .45-.06.68-.08L12 4h.59c.21 0 .43 0 .65.07l.29 1.63.1.56.53.2a5.62 5.62 0 011.53.88l.44.35.52-.19 1.56-.5c.14.17.28.35.4.53a8.84 8.84 0 01.59 1c.09.2.18.39.26.59l-1.26 1.04-.44.37.09.55a5.62 5.62 0 01.07.92 4.94 4.94 0 01-.07.87l-.09.56.44.37 1.27 1.06c-.08.21-.17.42-.27.62z"></path></svg></div>
                                    <div className={showFieldList ? "field-list field-list-show" : "field-list "}>
                                        {Object.entries(fieldList).map((key, i) => (
                                            // {key[0] ===}
                                            <div key={key[0]} className={availableFieldList.indexOf(key[0]) > -1 ? "form-group" : "d-none"}>
                                                <label className="checkbox-container">
                                                    {key[0]}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => {
                                                            setFieldList({
                                                                ...fieldList,
                                                                [key[0]]: e.target.checked,
                                                            });
                                                            localStorage.setItem('fieldList', JSON.stringify({
                                                                ...fieldList,
                                                                [key[0]]: e.target.checked,
                                                            }));
                                                        }}
                                                        id={key[0] + "_cb"}
                                                        name={key[0] + "_cb"}
                                                        checked={fieldList[key[0]] || false}
                                                        value={fieldList[key[0]] || false}
                                                    />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div> */}
                    </div>
                </div>
                {(user.role <= 2 || user.role <= 5) &&
                    <div className="lg:col-span-3 flex flex-col items-stretch gap-2 lg:items-end">
                        <NavLink to={"/manage/event-recap"} onClick={() => {}} className={primaryBtnCls}>
                            New Event Recap
                        </NavLink>
                        <NavLink to={"/manage/event-recaps"} onClick={() => {}} className={primaryBtnCls}>
                            Event Recaps
                        </NavLink>
                    </div>
                }
            </div>
            <div className="mt-6">
                <Fetching />
            </div>

            <div className="mt-6 flex justify-end">
                <SwitchField checked={simpleView} onChange={(checked) => {
                    setSimpleView(checked);
                    localStorage.setItem('simpleView', checked);
                }}>
                    Compact View
                </SwitchField>
            </div>
            <DataTable
                data={data.filtered || data.items}
                columns={columns}
                fixedHeader={true}
                defaultSortFieldId={1}
                pagination
                onChangePage={(page) => {
                    setRecFilters({ ...recFilters, pageIndex: page - 1 });
                }}
                expandableRows
                expandableRowsComponent={ExpandedRow}
                expandableRowsComponentProps={{ recFilters }} // Pass recFilters to ExpandedRow
                expandableRowsHideExpander={false}
                customStyles={customStyles}
                className="visible-scroll-y"
                striped
            //   onSelectedRowsChange={handleRowSelected}
            // paginationComponent={Pagination}
            />
            <div className="py-3"></div>
            <div className="py-3"></div>
            {/* <div className="py-3"></div>
            <h4 className="fs-xxl bold-font">Active Event Recaps</h4>
            <div className="row">
                {data.items.sort((a, b) => moment(a.startDate).format("YYYYMMDD") > moment(b.startDate).format("YYYYMMDD")).map((g, i) => {
                    if ((!searchText || g.sysname?.toLowerCase().indexOf(searchText.toLowerCase()) > -1) && g.status === "Active") {
                        return (
                            <div key={g.id} className="col-md-4 col-lg-3 pb-4">
                                <EventRecapCard item={g} key={i} id={i} index={i} moveCard={moveCard} updateData={() => { fetch(); }} />
                            </div>
                        )
                    }
                })}
            </div>
            <div className="py-3"></div>
            {showArchive &&
                <h4 className="fs-xxl bold-font">Archived Event Recaps</h4>
            }
            <div className="row">
                {data.items.sort((a, b) => moment(a.startDate).format("YYYYMMDD") > moment(b.startDate).format("YYYYMMDD")).map((g, i) => {

                    if ((!searchText || g.sysname?.toLowerCase().indexOf(searchText.toLowerCase()) > -1) && g.status === "Archived") {
                        return (
                            <div key={g.id} className="col-md-4 col-lg-3 pb-4">
                                <EventRecapCard item={g} key={i} id={i} index={i} moveCard={moveCard} updateData={() => { fetch(); }} />
                            </div>
                        )
                    }
                })}
            </div> */}
        </div>
    );
};

// data provides access to your row data
const ExpandedRow = ({ data, recFilters }) => {
    return <div className="box-border flex max-w-screen flex-row flex-wrap gap-6 px-3 py-3 sm:gap-12 sm:pl-12">
        {data?.galleryImages && data?.galleryImages.length > 0 ? (data.galleryImages.map((img, i) => (
            <div className="w-full md:w-1/4" key={i}>
                <img src={img.preview} alt={`Gallery ${i + 1}`} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} />
                <div className="w-full">
                    <div className="mt-2 max-h-[200px] overflow-y-auto">
                        {recFilters?.tags && Array.isArray(img?.caption) &&
                            img.caption
                                .sort((a, b) => {
                                    // Move tags in recFilters.tags to the beginning
                                    const isAInFilters = recFilters?.tags.includes(a);
                                    const isBInFilters = recFilters?.tags.includes(b);
                                    return isBInFilters - isAInFilters; // Sort descending: true (1) comes before false (0)
                                })
                                .map((caption, captionIndex) => (
                                    <div className="mb-2 mr-2 inline-flex" key={captionIndex}>
                                        <Tag
                                            active={recFilters?.tags.includes(caption)}
                                            className="select-none"
                                        >
                                            {caption}
                                        </Tag>
                                    </div>
                                ))}
                    </div>
                </div>
            </div>
        ))) : (
            <div className="w-full">
                <p>No gallery images available for this event recap.</p>
            </div>
        )}
    </div>
};

export default EventRecapGallery;
